import React, {Component} from 'react';
import {connect} from 'react-redux';
import Modal from 'react-modal';
import '../components/stylefeedback.css';


import {
    cancelAction as cancelActionRedux,
    confirmActionRequested,
    proceedAction as proceedActionRedux,
} from '../services/confirmAction/action';
import {addNotification} from "../services/notification/action";
import Translate from "./Translate";
import {deleteWebhook} from "../services/company/api";
import config from "../config";

const style = {
    overlay: {
        backgroundColor: config.modalBackgroundColor,
        zIndex: '2000',
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        borderRadius: '20px',
        transform: 'translate(-50%, -50%)',
        padding: '40px',
        border: 'none',
        minWidth: '396px',
        maxWidth: '960px',
    },
    title: {
        color: 'black',
        marginBottom: '20px',
        textAlign: 'center',
    },
    conversationInfo: {
        backgroundColor: '#f7f9fc',
        padding: '20px',
        borderRadius: '10px',
        marginBottom: '20px',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
        fontSize: '13px'
    },
    infoRow: {
        display: 'flex',
        gap: '10px',
        marginBottom: '10px',
    },
    _infoRow: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '10px',
    },
    label: {
        fontWeight: 'bold',
        color: 'rgb(4, 62, 92)',
        marginBottom: '5px',
    },
    value: {
        color: '#5a5a5a',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap',
    },
    buttonsWrapper: {
        display: 'flex',
        gap: '13px',
        marginTop: '15px',
    },
    blockBackground: {
        borderRadius: '50%',
        backgroundColor: 'red',
        width: '30px',
        height: '30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
};

const myDarkBlue = 'rgb(4, 62, 92)';
const styles = {
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        borderRadius: '20px',
        overflow: 'visible',
    },
    th: {
        padding: '12px 15px',
        backgroundColor: myDarkBlue,
        color: 'white',
        textAlign: 'left',
        cursor: 'pointer'
    },
    td: {
        border: `0`,
        padding: '12px 15px',
        textAlign: 'left',
        color: myDarkBlue,
    },
    parentTableDiv: {
        maxHeight: '295px',
        overflow: 'auto'
    },
};


Modal.setAppElement('#root');

class WebhooksModal extends Component {

    closeModal = () => {
        const {cancelAction} = this.props;
        cancelAction();
    };

    render() {
        let {isOpen, cancelAction, webhooks, setWebhooks, updateWebhooksState, setUpdateWebhooksState} = this.props;

        return (
            <Modal closeTimeoutMS={config.closeTimeoutMS} isOpen={isOpen} style={style} onRequestClose={this.closeModal}>
                <h2 style={style.title}><Translate text={'webhooks'}/> ({webhooks.length})</h2>
                <div>
                    <div style={styles.parentTableDiv}>
                        <table className={'custom-table'}>
                            <thead>
                            <tr>
                                <th
                                    key={'id'}
                                >
                                    <Translate text={'id'}/>
                                </th>
                                <th
                                    key={'API'}
                                >
                                    <Translate text={'api'}/>
                                </th>
                                <th
                                    key={'token'}
                                >
                                    <Translate text={'token'}/>
                                </th>
                                <th
                                    key={'headerName'}
                                >
                                    <Translate text={'headerName'}/>
                                </th>
                                <th
                                    key={'type'}
                                >
                                    <Translate text={'type'}/>
                                </th>
                                <th
                                    key={'actions'}
                                >
                                    <Translate text={'actions'}/>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {webhooks.sort((a, b) => a.id - b.id).map((webhook, index) => (
                                <tr key={index}
                                    className="border-td">
                                    <td>{webhook.id}</td>
                                    <td>{webhook.api}</td>
                                    <td>{webhook.token}</td>
                                    <td>{webhook.headerName}</td>
                                    <td><Translate text={webhook.type}/></td>
                                    <td>
                                        <div style={{
                                            display: 'flex',
                                            gap: '20px',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <button className="remove-btn" style={{marginTop: '3px'}}
                                                    onClick={() => {
                                                        deleteWebhook(webhook.companyId, webhook.id).then(res => {
                                                            setUpdateWebhooksState(!updateWebhooksState);
                                                            cancelAction();
                                                        }).catch(err => {
                                                            console.error("Error deleting webhook", err);
                                                        });
                                                    }}>
                                                ×
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>

            </Modal>
        );
    }
}

WebhooksModal.propTypes = {};

const mapStateToProps = state => ({
    isOpen: state.confirmAction.isModalOpen,
    user: state.user,
});

const mapDispatchToProps = dispatch => ({
    addNotification: () => {
        dispatch(addNotification());
    },
    proceedAction: () => {
        dispatch(proceedActionRedux());
    },
    cancelAction: () => {
        dispatch(cancelActionRedux());
    },
    confirmAction: (obj) => (dispatch(confirmActionRequested(obj.func, obj.args, obj.onCancel, obj.onCancelArgs, obj.content))),
});

export default connect(mapStateToProps, mapDispatchToProps)(WebhooksModal);



// WEBPACK FOOTER //
// ./src/components/WebhooksModal.jsx